// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { arrowExpanderUp16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { IconSvg, registerIconSvg } from '../../icon-svg';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-arrow-expander-up': IconArrowExpanderUp;
    }
}

/**
 * The icon component for the 'arrowExpanderUp' icon
 */
export class IconArrowExpanderUp extends IconSvg {
    public constructor() {
        super(arrowExpanderUp16X16);
    }
}

registerIconSvg('icon-arrow-expander-up', IconArrowExpanderUp);
export const iconArrowExpanderUpTag = 'nimble-icon-arrow-expander-up';
